/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpsertBasisOfCoverPayloadDto
 */
export interface UpsertBasisOfCoverPayloadDto {
    /**
     * 
     * @type {string}
     * @memberof UpsertBasisOfCoverPayloadDto
     */
    category: UpsertBasisOfCoverPayloadDtoCategoryEnum;
    /**
     * 
     * @type {string}
     * @memberof UpsertBasisOfCoverPayloadDto
     */
    basisOfCover: UpsertBasisOfCoverPayloadDtoBasisOfCoverEnum;
}


/**
 * @export
 */
export const UpsertBasisOfCoverPayloadDtoCategoryEnum = {
    Flood: 'Flood',
    Earthquake: 'Earthquake',
    Wind: 'Wind',
    Fire: 'Fire'
} as const;
export type UpsertBasisOfCoverPayloadDtoCategoryEnum = typeof UpsertBasisOfCoverPayloadDtoCategoryEnum[keyof typeof UpsertBasisOfCoverPayloadDtoCategoryEnum];

/**
 * @export
 */
export const UpsertBasisOfCoverPayloadDtoBasisOfCoverEnum = {
    AnyOneEvent: 'Any One Event',
    AnyOneLocation: 'Any One Location',
    InTheAggregate: 'In the Aggregate'
} as const;
export type UpsertBasisOfCoverPayloadDtoBasisOfCoverEnum = typeof UpsertBasisOfCoverPayloadDtoBasisOfCoverEnum[keyof typeof UpsertBasisOfCoverPayloadDtoBasisOfCoverEnum];


/**
 * Check if a given object implements the UpsertBasisOfCoverPayloadDto interface.
 */
export function instanceOfUpsertBasisOfCoverPayloadDto(value: object): value is UpsertBasisOfCoverPayloadDto {
    if (!('category' in value) || value['category'] === undefined) return false;
    if (!('basisOfCover' in value) || value['basisOfCover'] === undefined) return false;
    return true;
}

export function UpsertBasisOfCoverPayloadDtoFromJSON(json: any): UpsertBasisOfCoverPayloadDto {
    return UpsertBasisOfCoverPayloadDtoFromJSONTyped(json, false);
}

export function UpsertBasisOfCoverPayloadDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpsertBasisOfCoverPayloadDto {
    if (json == null) {
        return json;
    }
    return {
        
        'category': json['category'],
        'basisOfCover': json['basisOfCover'],
    };
}

export function UpsertBasisOfCoverPayloadDtoToJSON(json: any): UpsertBasisOfCoverPayloadDto {
    return UpsertBasisOfCoverPayloadDtoToJSONTyped(json, false);
}

export function UpsertBasisOfCoverPayloadDtoToJSONTyped(value?: UpsertBasisOfCoverPayloadDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'category': value['category'],
        'basisOfCover': value['basisOfCover'],
    };
}

